import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useHistory } from 'react-router-dom'
import '../styles/navbar-top.scss'
import Logo from '../images/logo_indo.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faHome, faVideo, faStore, faComments, faBell, faPaperPlane, faUserFriends } from '@fortawesome/free-solid-svg-icons'
import { useCookies } from 'react-cookie';

import NoProfile from '../images/no-profile.png'
import { useSelector } from 'react-redux';
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'

firebase.initializeApp({
    apiKey: "AIzaSyBorJDNVFAjnyK8eGTgMP2WOl59-2Au1a8",
    authDomain: "elivebylivelife.firebaseapp.com",
    projectId: "elivebylivelife",
    storageBucket: "elivebylivelife.appspot.com",
    messagingSenderId: "1019869524899",
    appId: "1:1019869524899:web:bce3c9f5697f29ac976016",
    measurementId: "G-6R1V7NBF6F"
});
const dbnotif = firebase.firestore()
let unsubscribe;
let unsubscribeCounting;

const NavbarTop = (props) => {
    let {
        inboxNew,
        inboxNewPerson,
        ChatPeople
    } = props
    const [cookies, setCookie, removeCookie] = useCookies(['']);
    const History = useHistory()
    const Profile = useSelector(state=>state.cacheState.profile)
    const [notification, setNotification] = useState([])
    const [notificationCount, setNotificationCount] = useState([])
    const [loadFirst, setLoadFirst] = useState(false)
    const [startAfterStore, setStartAfterStore] = useState([])
    const [notifLoad, setNotifLoad] = useState(false)
    const NotifTriggeredRef = useRef();
    const NotifRef = useRef();

    const NotifTriggered = useCallback(node=>{
        if (notifLoad) return
        if (Profile) {
            if (Profile.account_info) {
                if (NotifTriggeredRef.current) NotifTriggeredRef.current.disconnect()
                NotifTriggeredRef.current = new IntersectionObserver(entries=>{
                    if (entries[0].isIntersecting) {
                        getNotification(dbnotif, Profile.account_info.email, loadFirst)
                    }
                })
                if (node) NotifTriggeredRef.current.observe(node)
            }
        }
    },[notifLoad]);

    const goOnTop = () => {
        window.scroll({
            top: 0, 
            left: 0,
            behavior: 'smooth'
        });
    }

    const logout = () => {
        History.replace(`/login?event=${cookies.event}`)
        removeCookie('account')
        removeCookie('event')
        removeCookie('key')
        window.location.reload();
    }

    const goToNewTab = () => {
        const win = window.open(`https://livelifeindo.com/profile/view/${cookies['account']}`, "_blank");
        win.focus();
    }
  
    const handleClickToArticle = () => {
      window.open('https://blog.livelifeindo.com/');
    }

    const timeSince = (date) => {
        let dates = date.toDate()
        let seconds = Math.floor((new Date() - dates) / 1000);
        let interval = seconds / 31536000;
        if (interval > 1) {
            return Math.floor(interval) + " years ago";
        }
        interval = seconds / 2592000;
        if (interval > 1) {
            return Math.floor(interval) + " months ago";
        }
        interval = seconds / 86400;
        if (interval > 1) {
            return Math.floor(interval) + " days ago";
        }
        interval = seconds / 3600;
        if (interval > 1) {
            return Math.floor(interval) + " hours ago";
        }
        interval = seconds / 60;
        if (interval > 1) {
            return Math.floor(interval) + " minutes ago";
        }
        return Math.floor(seconds) + " seconds ago";
    }

    useEffect(()=>{
        if (Profile) {
            if (Profile.account_info) {
                getNotification(dbnotif, Profile.account_info.email, loadFirst)
                if (!loadFirst) setLoadFirst(true)
                unsubscribe = dbnotif.collection('notification')
                .where("email", '==', Profile.account_info.email)
                .orderBy('createdAt', 'desc')
                .limit(1)
                .onSnapshot(async res=>{
                    if (res) {
                        const data = res.docs.map(doc=>({
                            ...doc.data(),
                            id: doc.id
                        }))
                        if (data) {
                            setNotification(prev=> [...data, ...prev])
                        }
                    }
                })
            }
        }
    },[dbnotif, Profile])

    useEffect(()=>{
        if (Profile) {
            if (Profile.account_info) {
                unsubscribeCounting = dbnotif.collection('notification')
                .where("email", '==', Profile.account_info.email)
                .where("received", '==', false)
                .onSnapshot(async res=>{
                    if (res) {
                        const data = res.docs.map(doc=>({
                            ...doc.data(),
                        }))
                        if (data) {
                            setNotificationCount(data)
                        }
                    }
                })
            }
        }
    },[Profile])

    const getNotification = async (dbnotif, email, trigger) => {
        try {
            if (dbnotif) {
                setNotifLoad(true)
                await dbnotif
                .collection('notification')
                .where("email", '==', email)
                .orderBy('createdAt', 'desc')
                .startAfter(startAfterStore)
                .limit(6)
                .get()
                .then(async res => {
                    let data = res.docs.map(doc=> ({
                        ...doc.data(),
                        id: doc.id
                    }))
                    if (data) {
                        setStartAfterStore(res.docs[res.docs.length-1])
                        if (!trigger) {
                            data.shift()
                            setNotification(prev=> [ ...prev, ...data])
                        } else {
                            setNotification(prev=> [ ...prev, ...data])
                        }
                    }
                    setNotifLoad(false)
                })
            }
        } catch (error) {
            setNotifLoad(false)
        }
    }

    const handleLimitString = (str, limit) => {
        if (str) {
            if (str.length > limit) {
                return `${str.slice(0,limit)} ...`
            }
        }
        return str
    }

    const handleClickButton = (href) => {
        if (inboxNewPerson !== undefined) inboxNewPerson = undefined
        if (inboxNew !== undefined) inboxNew()
        if (ChatPeople !== undefined) ChatPeople()
        History.push(href)
        goOnTop()
    }

    return (
      <section className="topHeader">
        <div className="headerWrapper">
          <div className="headerInnerWrapper w-100 d-flex align-items-center justify-content-between">
            
            {/* Logo */}
            <img src={Logo} alt="icon" style={{marginLeft: '2rem'}}/>
      
            {/* Menu - desktop only */}
            <div className="menuWrapper d-none d-md-block" style={{ display: 'none' }}>
              <ul className="menuInnerWrapper">
                <li className={`menuItem ${History.location.pathname === '/home' && 'active'}`}
                  onClick={_ => History.location.pathname !== '/home' && handleClickButton('/home')}
                >
                  <span className="icon"><FontAwesomeIcon icon={faHome} /></span>
                  <span className="menuText">Home</span>
                </li>
                <li className={`menuItem ${History.location.pathname === '/stage' && 'active'}`}
                  onClick={_ => History.location.pathname !== '/stage' && handleClickButton('/stage')}
                >
                  <span className="icon"><FontAwesomeIcon icon={faVideo} /></span>
                  <span className="menuText">Sessions</span>
                </li>
                <li className={`menuItem ${History.location.pathname === '/people' && 'active'}`}
                  onClick={_ => History.location.pathname !== '/people' && handleClickButton('/people')}
                >
                  <span className="icon"><FontAwesomeIcon icon={faUserFriends} /></span>
                  <span className="menuText">People</span>
                </li>
                <li className={`menuItem ${History.location.pathname === '/article' && 'active'}`}
                  onClick={handleClickToArticle}
                >
                  <span className="icon"><FontAwesomeIcon icon={faStore} /></span>
                  <span className="menuText">Article</span>
                </li>
              </ul>
            </div>
      
            {/* Right Actions */}
            <div className="d-flex align-items-center gap-2">
              
              {/* Avatar */}
              <div className="avtLayout" style={{ cursor: 'pointer' }}>
                <span className="dropdown-toggle" id="dropUser" data-bs-toggle="dropdown" aria-expanded="false">
                  <img
                    src={Profile ? Profile.account_info.profile_photo : cookies['_US-IF'] && cookies['_US-IF'].profile_photo}
                    alt="avatar"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = NoProfile;
                    }}
                  />
                </span>
                <div className="dropdown-menu dropdown-menu-end dropTopHeadUsr" aria-labelledby="dropUser">
                  <div className="dropBodyProfile">
                    <span onClick={_ => goToNewTab()} className="dropdown-item">Profile</span>
                    <span onClick={_ => History.push('/edit-profile')} className="dropdown-item">Edit profile</span>
                    {cookies['key'] === 'author' &&
                      <span onClick={_ => History.push('/customize')} className="dropdown-item">Customize</span>
                    }
                    <span onClick={logout} className="dropdown-item">Logout</span>
                  </div>
                </div>
              </div>
      
              {/* Hamburger - mobile only */}
              <button
                className="d-flex d-md-none border-0 align-items-center justify-content-center rounded-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#mobileMenu"
                aria-controls="mobileMenu"
                aria-expanded="false"
                aria-label="Toggle navigation"
                style={{ color: '#555aea', backgroundColor: 'white', width: '38px', height: '38px', flexShrink: 0, marginRight: '2rem' }}
              >
                <FontAwesomeIcon icon={faBars} />
              </button>
      
            </div>
          </div>
      
          {/* Mobile Menu - collapsible */}
          <div className="collapse d-md-none" id="mobileMenu" style={{
                position: 'absolute',
                right: '1rem',
                top: '4rem',
                background: 'white'
          }}>
            <ul className="list-unstyled m-0 py-2 border-top">
              {[
                { path: '/home', icon: faHome, label: 'Home', onClick: _ => History.location.pathname !== '/home' && handleClickButton('/home') },
                { path: '/stage', icon: faVideo, label: 'Sessions', onClick: _ => History.location.pathname !== '/stage' && handleClickButton('/stage') },
                { path: '/people', icon: faUserFriends, label: 'People', onClick: _ => History.location.pathname !== '/people' && handleClickButton('/people') },
                { path: '/article', icon: faStore, label: 'Article', onClick: handleClickToArticle },
              ].map(({ path, icon, label, onClick }) => (
                <li
                  key={path}
                  className="d-flex align-items-center gap-3 px-4 py-3"
                  style={{
                    cursor: 'pointer',
                    color: History.location.pathname === path ? '#555aea' : '#333',
                    fontWeight: History.location.pathname === path ? '600' : '400',
                    borderLeft: History.location.pathname === path ? '3px solid #555aea' : '3px solid transparent',
                    backgroundColor: History.location.pathname === path ? '#f0f0ff' : 'transparent'
                  }}
                  onClick={onClick}
                >
                  <FontAwesomeIcon icon={icon} style={{ width: '16px' }} />
                  <span>{label}</span>
                </li>
              ))}
            </ul>
          </div>
      
        </div>
      </section>
    );
};

export default NavbarTop
